// @ts-nocheck
import Form, { Field, FormInstance } from "rc-field-form";
import * as React from "react";
import LocalStorageService from "../../auth/local-storage-service";
import { FireBaseService } from "../../firebase/firebase";
import { UserService } from "../../services/user-service";
import { KMainFunctions } from "../../shared/utility/main-functions";
import "../../styles/authentication.scss";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import KuikaCheckbox from "../ui-kit/kuika-checkbox/kuika-checkbox";
import KuikaInput from "../ui-kit/kuika-input/kuika-input";
import KuikaSvg from "../ui-kit/kuika-svg/kuika-svg";
import { toastService } from "../ui-kit/kuika-toast/toast-service";
import KuikaH4 from "../ui-kit/typography/H4/H4";
import KuikaSmallMediumText from "../ui-kit/typography/SmallMediumText/SmallMediumText";
import KuikaText from "../ui-kit/typography/Text/Text";
import { AuthLogo } from "./auth-logo";
import { AuthenticationBanner } from "./authentication-banner";

// KOA-17793: The standalone /signup screen was removed. This form is the only remaining
// registration surface and is reachable exclusively from an invitation (/invitation). The
// e-mail is fixed to the invited address and the submission always carries the invited
// workspace (domainName), so it hits the backend invitation branch (bypassing the
// platform @kuika.com self-signup restriction).
export interface IRegistrationFormProps {
  username: string;
  domainName?: string;
  onSuccess: () => void;
}

export interface IRegistrationFormState {
  isSigningUp: boolean;
  showPassword: boolean;
}

declare let window: Window & { [key: string]: any };

export class RegistrationForm extends React.PureComponent<IRegistrationFormProps, IRegistrationFormState> {
  formRef = React.createRef<FormInstance>();

  constructor(props: IRegistrationFormProps) {
    super(props);
    this.state = {
      isSigningUp: false,
      showPassword: false
    };
  }

  componentDidMount() {
    const firebase = new FireBaseService();
    firebase.logEvent("signup_screen_shown", { source: "invitation" });
  }

  onSubmit = async (data: any) => {
    this.setState({ isSigningUp: true });
    LocalStorageService.clearToken();
    window.userInfo = undefined;

    try {
      const res = await UserService.SignUp({
        ...data,
        username: this.props.username,
        domainName: this.props.domainName,
        VerifyEmailAddress: true
      });

      if (res === "") {
        this.props.onSuccess();
        return;
      }

      toastService.error(res);
    } catch (_error) {
      toastService.error("An error has been occurred. Please try again.");
    }
    this.setState({ isSigningUp: false });
  };

  termsAndPrivacyValidator = (_rule: any, value: any) => {
    const isMainAI = KMainFunctions.isMainAI();
    if (isMainAI) {
      return Promise.resolve();
    }
    if (value !== true) return Promise.reject(new Error(""));
    return Promise.resolve();
  };

  render() {
    const isMainAI = KMainFunctions.isMainAI();
    return (
      <div className="auth-page">
        <div className="auth-page__left">
          <div className="auth-page__body">
            <div className="auth-page__logo-section">
              <AuthLogo />
            </div>

            <KuikaH4>{isMainAI ? "Create your account" : "Create your Kuika account"}</KuikaH4>

            <div className="auth-page__form-section">
              <Form ref={this.formRef} onFinish={this.onSubmit} style={{ width: "100%" }}>
                <div className="auth-page__inputs-container">
                  <Field
                    name="username"
                    initialValue={this.props.username}
                    rules={[{ required: true, message: "Please enter your email" }]}
                  >
                    {(control, meta) => (
                      <div style={{ width: "100%" }}>
                        <KuikaInput
                          {...control}
                          id="signupUsername"
                          leftIcon={<KuikaSvg name="mail" width={12} height={12} />}
                          placeholder="Email"
                          readOnly
                          size="lg"
                          error={meta.errors.length > 0}
                          autoComplete="off"
                        />
                        <div style={{ minHeight: "20px" }}>
                          {meta.errors.length > 0 && (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <KuikaSvg name="info-circle" width={12} height={12} color="var(--red-5)" />
                              <KuikaSmallMediumText style={{ color: "var(--red-5)" }}>
                                {meta.errors[0]}
                              </KuikaSmallMediumText>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Field>

                  <div className="auth-page__inputs-row">
                    <Field
                      name="firstname"
                      rules={[
                        { required: true, message: "Please enter your first name" },
                        {
                          pattern: /^[\p{L}]+(?:[\s'-][\p{L}]+)*$/u,
                          message: "Please enter a valid first name"
                        }
                      ]}
                    >
                      {(control, meta) => (
                        <div style={{ width: "100%", flex: 1 }}>
                          <KuikaInput
                            {...control}
                            leftIcon={<KuikaSvg name="user" width={12} height={12} />}
                            placeholder="First name"
                            size="lg"
                            error={meta.errors.length > 0}
                          />
                          <div style={{ minHeight: "20px" }}>
                            {meta.errors.length > 0 && (
                              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <KuikaSvg name="info-circle" width={12} height={12} color="var(--red-5)" />
                                <KuikaSmallMediumText style={{ color: "var(--red-5)" }}>
                                  {meta.errors[0]}
                                </KuikaSmallMediumText>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </Field>
                    <Field
                      name="lastname"
                      rules={[
                        { required: true, message: "Please enter your last name" },
                        {
                          pattern: /^[\p{L}]+(?:[\s'-][\p{L}]+)*$/u,
                          message: "Please enter a valid last name"
                        }
                      ]}
                    >
                      {(control, meta) => (
                        <div style={{ width: "100%", flex: 1 }}>
                          <KuikaInput {...control} placeholder="Last name" size="lg" error={meta.errors.length > 0} />
                          <div style={{ minHeight: "20px" }}>
                            {meta.errors.length > 0 && (
                              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <KuikaSvg name="info-circle" width={12} height={12} color="var(--red-5)" />
                                <KuikaSmallMediumText style={{ color: "var(--red-5)" }}>
                                  {meta.errors[0]}
                                </KuikaSmallMediumText>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </Field>
                  </div>

                  <Field
                    name="password"
                    rules={[
                      { required: true, message: "Please enter your password" },
                      { min: 8, message: "Password length must be at least 8" },
                      { pattern: /(?=.*[a-z])/, message: "Password must contain at least 1 lowercase character" },
                      { pattern: /(?=.*[A-Z])/, message: "Password must contain at least 1 uppercase character" },
                      {
                        pattern: /(?=.*[!@#$%^&*(),.?":{}|<>\-_])/,
                        message: "Password must contain at least 1 special character"
                      },
                      {
                        validator: (_, value) => {
                          if (value && /(0123|1234|2345|3456|4567|5678|6789|7890)/.test(value)) {
                            return Promise.reject(new Error("Password must not contain more than 3 sequential digits"));
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                  >
                    {(control, meta) => (
                      <div style={{ width: "100%" }}>
                        <KuikaInput
                          {...control}
                          type={this.state.showPassword ? "text" : "password"}
                          leftIcon={<KuikaSvg name="lock" width={12} height={12} />}
                          placeholder="Password"
                          size="lg"
                          error={meta.errors.length > 0}
                          autoComplete="new-password"
                          rightUnit={
                            <KuikaSvg
                              name={this.state.showPassword ? "eye" : "eye-closed"}
                              pointer
                              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                            />
                          }
                        />
                        <div style={{ minHeight: "20px" }}>
                          {meta.errors.length > 0 && (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <KuikaSvg name="info-circle" width={12} height={12} color="var(--red-5)" />
                              <KuikaSmallMediumText style={{ color: "var(--red-5)" }}>
                                {meta.errors[0]}
                              </KuikaSmallMediumText>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Field>
                </div>

                {!isMainAI && (
                  <div className="auth-page__checkbox-row">
                    <Field
                      name="termsAndPrivacy"
                      rules={[{ validator: this.termsAndPrivacyValidator }]}
                      valuePropName="checked"
                    >
                      {(control, meta) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <KuikaCheckbox
                            {...control}
                            label=""
                            className={meta.errors.length > 0 ? "auth-page__checkbox-error" : undefined}
                            onChange={(e) => {
                              control.onChange(e.target.checked);
                            }}
                          />
                          <KuikaText style={{ marginLeft: 8, color: "var(--dark)" }}>
                            I agree to the
                            <a
                              href="https://www.kuika.com/en/legal/terms"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "var(--accent-fg)",
                                fontWeight: 400,
                                fontSize: 14,
                                margin: "0 4px",
                                textDecoration: "none"
                              }}
                            >
                              Terms of Services
                            </a>
                            and
                            <a
                              href="https://www.kuika.com/en/legal/privacy"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "var(--accent-fg)",
                                fontWeight: 400,
                                fontSize: 14,
                                margin: "0 0 0 4px",
                                textDecoration: "none"
                              }}
                            >
                              Privacy Policy
                            </a>
                            .
                          </KuikaText>
                        </div>
                      )}
                    </Field>
                  </div>
                )}

                <div className="auth-page__actions">
                  <KuikaButton
                    id="sign-up-button"
                    htmlType="submit"
                    size="lg"
                    loading={this.state.isSigningUp}
                    className="kuika-width-full"
                    uppercase
                  >
                    Sign up
                  </KuikaButton>
                </div>
              </Form>
            </div>
          </div>

          <div className="auth-page__footer">
            {!isMainAI && (
              <>
                <KuikaButton
                  type="text"
                  size="sm"
                  onClick={() => window.open("https://www.kuika.com/en/legal/privacy", "_blank")}
                >
                  PRIVACY
                </KuikaButton>
                <KuikaButton
                  type="text"
                  size="sm"
                  onClick={() => window.open("https://www.kuika.com/en/legal/terms", "_blank")}
                >
                  TERMS
                </KuikaButton>
              </>
            )}
          </div>
        </div>

        <AuthenticationBanner />
      </div>
    );
  }
}
